export default {
  openButton: "Generar estructura curricular con IA",
  title: "Creación rápida con IA — Estructura Curricular",
  close: "Cerrar",
  // Fallbacks de los nombres alternativos institucionales: el componente
  // los pasa por $getVisibleNames y usa estos textos si la institución no
  // renombró el concepto.
  unitLabel: "Unidad de Competencia",
  studyUnitLabel: "Unidad de Estudio",
  studyUnitsLabel: "Unidades de Estudio",
  criterionLabel: "Indicador de Logro",
  criteriaTitle: "Indicadores de Logro",
  contentLabel: "Contenido",
  contentsTitle: "Contenidos",
  empty:
    "No hay estructura curricular para mostrar ni propuestas generadas.",
  addUnitButton: "Agregar {entity} con IA",
  addUnitThemePlaceholder: "Tema para la nueva {entity} (opcional)",
  addUnitThemeHint:
    "Genera una {entity} nueva con sus {study_units}, {criteria} y {contents}.",
  addUnitThemeInfo:
    "Opcional: indica en pocas palabras el tema o énfasis de la nueva {entity}; la IA generará también sus {study_units}, {criteria} y {contents}. Ej.: “calidad de software”, “gestión de proyectos”.",
  addUnitThemeHintNoContents:
    "Genera una {entity} nueva con sus {study_units} y {criteria}.",
  addUnitThemeInfoNoContents:
    "Opcional: indica en pocas palabras el tema o énfasis de la nueva {entity}; la IA generará también sus {study_units} y {criteria}. Ej.: “calidad de software”, “gestión de proyectos”.",
  addStudyUnitButton: "Agregar {entity} con IA",
  addStudyUnitThemePlaceholder: "Tema para la nueva {entity} (opcional)",
  addStudyUnitThemeHint:
    "Genera una {entity} nueva (resultado de aprendizaje) con sus {criteria} y {contents}.",
  addStudyUnitThemeInfo:
    "Opcional: indica en pocas palabras el tema del nuevo resultado de aprendizaje; la IA generará también sus {criteria} y {contents}. Ej.: “pruebas unitarias”, “bases de datos NoSQL”.",
  addStudyUnitThemeHintNoContents:
    "Genera una {entity} nueva (resultado de aprendizaje) con sus {criteria}.",
  addStudyUnitThemeInfoNoContents:
    "Opcional: indica en pocas palabras el tema del nuevo resultado de aprendizaje; la IA generará también sus {criteria}. Ej.: “pruebas unitarias”, “bases de datos NoSQL”.",
  addCriteriaButton: "Agregar {entity} con IA",
  addCriteriaThemePlaceholder: "Tema para el nuevo {entity} (opcional)",
  addCriteriaThemeHint: "Genera un {entity} nuevo para esta {study_unit}.",
  addCriteriaThemeInfo:
    "Opcional: indica en pocas palabras el aspecto que debe evaluar el nuevo {entity}. Ej.: “trabajo en equipo”, “documentación técnica”.",
  addContentButton: "Agregar {entity} con IA",
  addContentThemePlaceholder: "Tema para el nuevo {entity} (opcional)",
  addContentThemeHint: "Genera un {entity} nuevo para esta {study_unit}.",
  addContentThemeInfo:
    "Opcional: indica en pocas palabras el tema del nuevo {entity}. Ej.: “patrones de diseño”, “consultas SQL avanzadas”.",
  generating: "Generando contenido con IA...",
  generateError:
    "No fue posible generar el contenido. Intente nuevamente más tarde.",
  cancel: "Cancelar",
  confirmSave: "Confirmar y guardar",
  savedToast: "Objetos creados correctamente.",
  saveError:
    "Ocurrió un error al guardar los objetos generados. Intente nuevamente.",
};
